import * as actionTypes from "./actionTypes";

export function createFormlayoutJSON(payload) {
    return {
        type: actionTypes.CREATE_FORMLAYOUT_JSON,
        payload,
    };
}

export function resetReport() {
    return {
        type: actionTypes.RESET_WARRANTIES_REPORT,
    };
}
export function createFormlayoutJSONSuccess(data) {
    return {
        type: actionTypes.CREATE_FORMLAYOUT_JSON_SUCCESS,
        ...data,
    };
}

export function createFormlayoutJSONFailure(errors) {
    return {
        type: actionTypes.CREATE_FORMLAYOUT_JSON_FAILURE,
        errors,
    };
}

export function refreshRedisCache(payload) {
    return {
        type: actionTypes.REFRESH_REDIS_CACHE,
        payload,
    };
}

export function refreshRedisCacheSuccess(data) {
    return {
        type: actionTypes.REFRESH_REDIS_CACHE_SUCCESS,
        ...data,
    };
}

export function refreshRedisCacheFailure(errors) {
    return {
        type: actionTypes.REFRESH_REDIS_CACHE_FAILURE,
        errors,
    };
}

export function refreshActionScopes(payload) {
    return {
        type: actionTypes.REFRESH_ACTION_SCOPES,
        payload,
    };
}

export function refreshActionScopesSuccess(data) {
    return {
        type: actionTypes.REFRESH_ACTION_SCOPES_SUCCESS,
        ...data,
    };
}

export function refreshActionScopesFailure(errors) {
    return {
        type: actionTypes.REFRESH_ACTION_SCOPES_FAILURE,
        errors,
    };
}


export function refreshPropertyManagerJson(payload) {
    return {
        type: actionTypes.REFRESH_PROPERTY_MANAGER_JSON,
        payload,
    };
}

export function refreshPropertyManagerJsonSuccess(data) {
    return {
        type: actionTypes.REFRESH_PROPERTY_MANAGER_JSON_SUCCESS,
        ...data,
    };
}

export function refreshPropertyManagerJsonFailure(errors) {
    return {
        type: actionTypes.REFRESH_PROPERTY_MANAGER_JSON_FAILURE,
        errors,
    };
}

export function apiDeepHealthCheck(payload) {
    return {
        type: actionTypes.API_DEEP_HEALTH_CHECK,
        payload,
    };
}

export function apiDeepHealthCheckSuccess(data) {
    return {
        type: actionTypes.API_DEEP_HEALTH_CHECK_SUCCESS,
        ...data,
    };
}

export function apiDeepHealthCheckFailure(errors) {
    return {
        type: actionTypes.API_DEEP_HEALTH_CHECK_FAILURE,
        errors,
    };
}
